<template>
  <b-card>
    <b-card-header v-if="revendedora.precadastro_id" class="mb-2">
      <b>Importando pré-cadastro {{ revendedora.precadastro_id }}</b>
    </b-card-header>
    <b-form class="mt-3" @submit="saveRevendedora">
      <b-tabs v-model="tabForm" content-class="mt-3" justified>
        <b-tab title="Dados" active>
          <b-form-group
            label="Cadastro Indicado Por:"
            v-if="
              distribuidor_codigo == '0061388' &&
              (!revendedora.id ||
                (revendedora.id > 0 && revendedora.indicada_por > 0))
            "
            label-for="indicada-por"
            label-class="font-weight-bold pt-0"
            class="mb-0"
          >
            <b-form-select
              :disabled="revendedora.id > 0"
              v-model="revendedora.indicada_por"
              :options="optionsRevend"
            />
          </b-form-group>
          <b-form-group
            label="Ponto de Venda"
            v-if="pdvs.length > 0"
            label-for="indicada-por"
            label-class="font-weight-bold pt-0"
            class="mb-0"
          >
            <b-form-select v-model="revendedora.pdv" :options="optionsPDV" />
          </b-form-group>
          <b-row class="mt-3">
            <b-col md="6" sm="12">
              <b-form-group
                label="Nome:"
                label-for="nome"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="nome"
                  v-model="revendedora.nome"
                  placeholder="Nome"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" sm="12">
              <b-form-group
                :description="
                  classe_distribuidor === 'G' ? 'O CPF deve ser preenchido' : ''
                "
                label="CPF:"
                label-cols-sm="3"
                label-align="right"
                label-for="cpf"
                valid-feedback="CPF Válido"
                :invalid-feedback="invalidCpf"
                :state="stateCPF"
              >
                <b-form-input
                  id="cpf"
                  v-model="revendedora.cpf"
                  v-mask="'###.###.###-##'"
                  :state="stateCPF"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6" sm="12">
              <b-form-group
                label="Ativa:"
                label-for="ativa"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-select
                  id="desconto"
                  v-model="revendedora.status"
                  :options="status"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" sm="12">
              <b-form-group
                label="E-mail:"
                label-for="email"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="email"
                  v-model="revendedora.email"
                  placeholder="E-mail"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6" sm="12">
              <b-form-group
                label="Desconto (%):"
                label-for="desconto"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="desconto"
                  v-model="revendedora.desconto"
                  :type="'number'"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" sm="12">
              <b-form-group
                label="RG:"
                label-for="rg"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="rg"
                  placeholder="RG"
                  v-model="revendedora.rg"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6" sm="12">
              <b-form-group
                label="Data Nasc.:"
                label-for="dataNc"
                label-cols-sm="3"
                label-align="right"
              >
                <date-picker
                  id="dataNc"
                  v-model="revendedora.data_nasc"
                  :config="datePickerConfig"
                ></date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6" sm="12">
              <b-form-group
                label="CEP:"
                label-for="cep"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="cep"
                  placeholder="CEP"
                  v-model="revendedora.cep"
                  v-mask="'## ###-###'"
                  @keyup="buscacep"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" sm="12">
              <b-form-group
                label="Logradouro:"
                label-for="logradouro"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="logradouro"
                  placeholder="Logradouro"
                  v-model="revendedora.logradouro"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6" sm="12">
              <b-form-group
                label-for="bairro"
                label="Bairro:"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="bairro"
                  placeholder="Bairro"
                  v-model="revendedora.bairro"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" sm="12">
              <b-form-group
                label-for="complemento"
                label="Complemento:"
                label-cols-sm="3"
                label-align="right"
              >
                <b-form-input
                  id="complemento"
                  placeholder="Complemento"
                  v-model="revendedora.complemento"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col md="6" sm="12">
              <b-form-group
                label-for="cidade"
                label="Cidade:"
                label-cols-sm="3"
                label-align="right"
              >
                <select
                  name=""
                  id="cidade"
                  class="form-control"
                  v-model="revendedora.cidade"
                  disabled=""
                >
                  <option value="-1" disabled="">Selecione Cidade</option>
                  <option
                    :value="cidade.ibge"
                    v-for="(cidade, c) in cidades"
                    :key="c"
                  >
                    {{ cidade.nome }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
            <b-col md="6" sm="12">
              <b-form-group
                label-for="estado"
                label="Estado:"
                label-cols-sm="3"
                label-align="right"
              >
                <select
                  name=""
                  id="estado"
                  class="form-control"
                  v-model="revendedora.estado"
                  @change="getCidades"
                  disabled=""
                >
                  <option value="-1" disabled="">Selecione Estado</option>
                  <option
                    :value="estado.uf"
                    v-for="(estado, e) in estados"
                    :key="e"
                  >
                    {{ estado.nome }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="distribuidor_codigo == '0667668' || distribuidor_codigo == '0667814' || distribuidor_codigo == '1966612'" class="pedido-pessoal">
            <b-col>
              <b-form-group
                label-for="empresa"
                label="Empresa:"
                label-cols-sm="3"
                label-align="right"
                class="mt-3"
              >
                <b-form-select
                  v-model="revendedora.empresa"
                  :options="optionsEmpresa"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-for="local"
                label="Entrega:"
                label-cols-sm="3"
                label-align="right"
                class="mt-3"
              >
                <b-form-select
                  v-model="revendedora.local_entrega"
                  :options="optionsEntrega"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Telefones">
          <b-button variant="success" @click="addContato">
            <i class="fa fa-plus" /> Contato</b-button
          >
          <div
            class="row mt-3"
            v-for="(contato, index) in revendedora.contatos"
            :key="index"
          >
            <div class="col-md-6 col-sm-12">
              <label for="">Tipo</label>
              <select name="" id="" class="form-control" v-model="contato.tipo">
                <option value="F">Fixo</option>
                <option value="M">Móvel</option>
              </select>
            </div>

            <div class="col-md-6 col-sm-12">
              <label for="">Numero</label>
              <input
                type="text"
                class="form-control"
                v-mask="['(##) ####-####', '(##) #####-####']"
                v-model="contato.numero"
              />
            </div>

            <div class="col-md-6 col-sm-12">
              <label for="">Whatsapp</label>
              <select
                name=""
                id=""
                class="form-control"
                v-model="contato.whatsapp"
              >
                <option :value="0">Não</option>
                <option :value="1">Sim</option>
              </select>
            </div>
            <div class="col-md-6 col-sm-12 mt-3">
              <p class="btn-remove-contato">
                <button class="btn btn-danger" @click="removeContato(index)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </p>
            </div>
          </div>
        </b-tab>
        <b-tab title="Usuário Revenda" v-if="revendedora.id">
          <b-row class="mb-3 ml-3">
            <b-col>
              <b-form-checkbox
                @change="limpaAcessoApp"
                v-model="revendedora.loginApp"
                name="check-button"
                switch
              >
                Acesso a Revenda
              </b-form-checkbox>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>CPF</label>
                <b-form-input
                  :disabled="revendedora.loginApp === false"
                  v-model="revendedora.acessoCPF"
                  autofocus
                  v-mask="'###########'"
                />
              </div>
              <div class="form-group">
                <label>Senha</label>
                <b-form-input
                  :disabled="revendedora.loginApp === false"
                  v-model="revendedora.senha_app"
                  :type="'password'"
                />
              </div>
              <div class="form-group">
                <label>Confirma Senha</label>
                <b-form-input
                  :disabled="revendedora.loginApp === false"
                  v-model="revendedora.confirmaSenha_app"
                  :type="'password'"
                />
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Usuário APP" v-if="revendedora.id">
          <b-row class="mb-3 ml-3">
            <b-col>
              <b-form-checkbox
                @change="limpaAcessoApp()"
                v-model="revendedora.app.ativo"
                switch
              >
                Acesso ao Aplicativo
              </b-form-checkbox>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Senha</label>
                <b-form-input
                  :disabled="!revendedora.app.ativo"
                  v-model="revendedora.app.senha"
                  :type="'password'"
                />
              </div>
              <div class="form-group">
                <label>Confirma Senha</label>
                <b-form-input
                  :disabled="!revendedora.app.ativo"
                  v-model="revendedora.app.confirma"
                  :type="'password'"
                />
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-form>
  </b-card>
</template>

<script>
const validar = (cpf) => checkAll(prepare(cpf));

const notDig = (i) => ![".", "-", " "].includes(i);
const prepare = (cpf) => cpf.trim().split("").filter(notDig).map(Number);
const is11Len = (cpf) => cpf.length === 11;
const notAllEquals = (cpf) => !cpf.every((i) => cpf[0] === i);
const onlyNum = (cpf) => cpf.every((i) => !isNaN(i));

const calcDig = (limit) => (a, i, idx) => a + i * (limit + 1 - idx);
const somaDig = (cpf, limit) => cpf.slice(0, limit).reduce(calcDig(limit), 0);
const resto11 = (somaDig) => 11 - (somaDig % 11);
const zero1011 = (resto11) => ([10, 11].includes(resto11) ? 0 : resto11);

const getDV = (cpf, limit) => zero1011(resto11(somaDig(cpf, limit)));
const verDig = (pos) => (cpf) => getDV(cpf, pos) === cpf[pos];

const checks = [is11Len, notAllEquals, onlyNum, verDig(9), verDig(10)];
const checkAll = (cpf) => checks.map((f) => f(cpf)).every((r) => !!r);

import { mask } from "vue-the-mask";
export default {
  name: "CadastroRevendedora",
  directives: {
    mask,
  },

  props: {
    ismodal: {
      type: Boolean,
      default: false,
    },
    revendedora: {
      type: Object,
      default: {
        id: null,
        nome: null,
        indicada_por: null,
        email: null,
        status: 1,
        dnto: 30,
        cpf: null,
        rg: null,
        data_nasc: null,
        cep: null,
        cidade: null,
        estado: -1,
        logradouro: null,
        bairro: null,
        complemento: null,
        contatos: [],
        pdv: 0,
        login: null,
        usuario: null,
        valida: false,
        precadastro_id: null,
        loginApp: false,
        acessoCPF: null,
        senha_app: null,
        confirmaSenha_app: null,
        empresa: null,
        local_entrega: null,
        app: {
          senha: "",
          confirma: "",
          user: null,
        },
      },
    },

    classe_distribuidor: {
      type: String,
      default: "G",
    },
    codigoDistribuidor: {
      type: [String, null],
      default: null,
    },
    cria_pdv: {
      type: Boolean,
      default: false,
    },
    meu_estado: {
      type: String,
    },
    lista_revendedoras: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      tabForm: 0,
      optionsEmpresa: [
        {
          value: null,
          text: "Selecione a Empresa",
        },
        {
          value: "CTIC",
          text: "CTIC",
        },
        {
          value: "INFINITY",
          text: "INFINITY",
        },
        {
          value: "NEXUS",
          text: "NEXUS",
        },
        {
          value: "INOVACAO",
          text: "INOVAÇÃO",
        },
        {
          value: "GLOW WEB",
          text: "GLOW WEB",
        },
        {
          value: "ESSENCE",
          text: "ESSENCE",
        },        
        {
          value: "ATUAL",
          text: "ATUAL",
        },
        {
          value: "GESTAO_INTELIGENTE",
          text: "GESTÃO INTELIGENTE",
        },
      ],
      optionsEntrega: [
        {
          value: null,
          text: "Selecione o Local de Entrega",
        },
        {
          value: "CTIC",
          text: "CTIC",
        },
        {
          value: "INFINITY",
          text: "INFINITY",
        },
        {
          value: "LEAD",
          text: "LEAD",
        },
        {
          value: "ESCRITORIO",
          text: "ESCRITORIO",
        },
        {
          value: "FABRICA",
          text: "FABRICA",
        },
        {
          value: "GRAVACAO",
          text: "GRAVAÇÃO",
        },
        {
          value: "TRANSPORTE",
          text: "TRANSPORTE",
        },
      ],
      status: [
        {
          value: 1,
          text: "Sim",
        },
        {
          value: 0,
          text: "Não",
        },
      ],
      estados: [],
      cidades: [],
      pdvs: [],
      estado: -1,
      cidade: -1,
      datePickerConfig: {
        format: "DD/MM/YYYY",
      },
      senha_app: "",
      confirmasenha_app: "",
      hideBtn: false,
      optionsTipo: [
        {
          value: "F",
          text: "Fixo",
        },
        {
          value: "M",
          text: "Celular",
        },
      ],
      tipo: "",
      telefone: "",
      whatsapp: true,
      distribuidor_codigo: "",
    };
  },
  methods: {
    getDistribuidor() {
      const vm = this;
      axios.get("/distribuidor/get").then((response) => {
        vm.distribuidor_codigo = response.data.codigo;
      });
    },
    limpaAcessoApp() {
      this.revendedora.acessoCPF = null;
      this.revendedora.senha_app = null;
      this.revendedora.confirmaSenha_app = null;
    },
    onContext(ctx) {
      this.formatted = ctx.selectedFormatted;
      this.selected = ctx.selectedYMD;
    },

    showModal() {
      isshowModal = !isshowModal;
    },

    addContato() {
      if (!this.revendedora.contatos) {
        this.revendedora.contatos = [
          {
            tipo: "F",
            numero: "",
            whatsapp: 0,
          },
        ];
      } else {
        this.revendedora.contatos.push({
          tipo: "F",
          numero: "",
          whatsapp: 0,
        });
      }
    },
    removeContato(index) {
      if (
        this.revendedora.contatos.length == 1 &&
        this.classe_distribuidor === "G"
      ) {
        this.$swal(
          "O contato é Obrigatório!",
          "informe ao menos um contato para prosseguir",
          "error"
        );
        return;
      }
      this.revendedora.contatos.splice(index, 1);
    },

    getEstados() {
      var vm = this;
      $(".loading").show();
      axios
        .get("/estados")
        .then(function (response) {
          vm.estados = response.data;
          $(".loading").hide();
        })
        .catch(function (error) {
          alert("Erro ao buscar estados");
          console.log(error);
          $(".loading").hide();
        });
    },
    getCidades() {
      var vm = this;
      $(".loading").show();
      axios
        .get("/cidades/" + this.meu_estado)
        .then(function (response) {
          vm.cidades = response.data;
          $(".loading").hide();
        })
        .catch(function (error) {
          alert("Erro ao buscar cidades.");
          console.log(error);
          $(".loading").hide();
        });
    },
    buscacep() {
      let numCep = this.revendedora.cep.replace(/[^0-9]/g, "");

      if (numCep.length === 0) {
        //this.clearEndereco();
        return;
      } else if (numCep.length != 8) {
        return;
      }

      var vm = this;
      $(".loading").show();
      $.getJSON("//viacep.com.br/ws/" + numCep + "/json/", function (dados) {
        if ("erro" in dados) {
          alert("Endereço não encontrado");
          console.log(dados);
          $(".loading").hide();
          //vm.clearEndereco();
          return;
        } else if (
          dados.uf !== vm.meu_estado &&
          vm.classe_distribuidor === "G" &&
          vm.codigoDistribuidor != '0670300' // Permitindo que este dist cadastre revendedoras de outro estado.
        ) {
          alert("A Revendedora deve pertencer a seu Estado (UF)");
          $(".loading").hide();
          //vm.clearEndereco();
          return;
        }
        if(vm.codigoDistribuidor == '0670300' && dados.uf != 'MA' && dados.uf != 'PI') {
          alert("Essa revendedora deve pertencer ao seu estado, ou a um estado associado a voce");
          $(".loading").hide();
          return;
        }

        vm.revendedora.bairro = dados.bairro;
        vm.revendedora.logradouro = dados.logradouro;
        vm.revendedora.complemento = dados.complemento;
        vm.revendedora.cidade = dados.ibge;
        vm.revendedora.estado = dados.uf;
        vm.getCidades();
        $(".loading").hide();
      });
    },
    getPDV() {
      var vm = this;
      $(".loading").show();
      axios

        .get("/distribuidor/pdv/listar")
        .then(function (response) {
          vm.pdvs = response.data;

          $(".loading").hide();
        })
        .catch(function (error) {
          alert(error.response.data.errors.join("\n"));

          $(".loading").hide();
          console.log(error.response);
        });
    },
    ocultaBtn(status) {
      this.hideBtn = status;
    },

    async saveRevendedora() {
      const vm = this;
      vm.valida = true;
      if (!this.validarRevendedora()) {
        vm.valida = false;
        return;
      }
      var data = {
        nome: this.revendedora.nome,
        email: this.revendedora.email,
        status: this.revendedora.status,
        desconto: this.revendedora.desconto,
        cpf: this.revendedora.cpf,
        rg: this.revendedora.rg,
        data_nasc: this.revendedora.data_nasc,
        cep: this.revendedora.cep,
        cidade: this.revendedora.cidade,
        logradouro: this.revendedora.logradouro,
        bairro: this.revendedora.bairro,
        complemento: this.revendedora.complemento,
        contatos: this.revendedora.contatos,
        pdv: this.revendedora.pdv,
        loginApp: this.revendedora.loginApp,
        loginCPF: this.revendedora.loginApp ? this.revendedora.acessoCPF : null,
        senha_app: this.revendedora.loginApp        
          ? this.revendedora.senha_app
          : null,
        confirmaSenha_app: this.revendedora.loginApp
          ? this.revendedora.confirmaSenha_app
          : null,
        revendedora_id: this.revendedora.id,
        app: this.revendedora.app,
        empresa: this.distribuidor_codigo == '0667668' || this.distribuidor_codigo == '0667814' || this.distribuidor_codigo == '1966612' ? this.revendedora.empresa : null,
        local_entrega: this.distribuidor_codigo == '0667668' || this.distribuidor_codigo == '0667814' || this.distribuidor_codigo == '1966612' ? this.revendedora.local_entrega : null
      };

      if (this.revendedora.precadastro_id) {
        data.precadastro_id = this.revendedora.precadastro_id;
      }

      var url = "/distribuidor/revendedora";

      if (this.revendedora.id) {
        url += "/" + this.revendedora.id;
        data["_method"] = "PUT";
      } else {
        if (this.revendedora.indicada_por) {
          data.indicada_por = this.revendedora.indicada_por;
        }
      }

      $(".loading").show();
      await axios
        .post(url, data)
        .then((response) => {
          $(".loading").hide();
          this.$swal.fire({
            title: "Revendedora salva com sucesso",
            icon: "success",
          });
          vm.$emit("saveRevendedora", vm.revendedora, vm.valida);
          vm.$emit("closeModal", false);
          return;
        })
        .catch((error) => {
          const errors = error.response.data.errors;
          console.log(error);
          vm.valida = false;
          this.$swal.fire({
            title: "Atenção",
            icon: "error",
            text: errors,
          });
        })
        .finally(() => {
          $(".loading").hide();
        });
    },
    validarRevendedora() {
      if (
        this.revendedora.app &&
        this.revendedora.app.ativo &&
        this.revendedora.app.senha.length > 0
      ) {
        if (this.revendedora.app.senha.length < 6) {
          this.$swal(
            "Atenção",
            "A senha deve ter no mínimo 6 dígitos!",
            "error"
          );
          return false;
        }
        if (this.revendedora.app.senha == "123456") {
          this.$swal(
            "Atenção",
            "A senha não atende aos requisitos mínimos",
            "error"
          );
          return false;
        }
        if (this.revendedora.app.senha !== this.revendedora.app.confirma) {
          this.$swal(
            "Atenção",
            "A senha e a confirmação não são iguais!",
            "error"
          );
          return false;
        }
        if (!this.revendedora.cpf && !this.revendedora.email) {
          this.$swal(
            "Atenção",
            "O cpf ou email é obrigatório para acesso ao app!",
            "error"
          );
        }
      }
      if (this.revendedora.nome.length < 5) {
        this.$swal("Nome é Obrigatório com pelo menos 5 letras!", "", "error");
        $(' a[href="#first-tab"]').tab("show");
        return false;
      }
      let localDesconto = this.revendedora.desconto + "";
      let descontoFloat = parseFloat(localDesconto.replace(",", "."));
      if (isNaN(descontoFloat) || descontoFloat <= 0) {
        this.$swal("O Desconto é Obrigatório!", "", "error");
        $(' a[href="#first-tab"]').tab("show");
        return false;
      }

      if (!this.validateContatos()) {
        return false;
      }

      if (this.revendedora.data_nasc) {
        if (typeof this.revendedora.data_nasc === "string") {
          var from = this.revendedora.data_nasc.indexOf("/");

          if (from > -1) {
            let dataa = this.revendedora.data_nasc.split("/");
            if (dataa.length > 0) {
              this.revendedora.data_nasc = moment(
                dataa[2] + "-" + dataa[1] + "-" + dataa[0]
              ).format("YYYY-MM-DD");
            }
          }
        }
      }

      if (!this.validatePF()) {
        $(' a[href="#first-tab"]').tab("show");
        return false;
      }

      if (!this.validateEndereco()) {
        $(' a[href="#first-tab"]').tab("show");
        return false;
      }

      return true;
    },
    validatePF() {
      if (!this.revendedora.cpf) {
        this.revendedora.cpf = "";
      }

      if (!this.revendedora.rg) {
        this.revendedora.rg = "";
      }

      if (
        !this.classe_distribuidor === "G" &&
        this.revendedora.cpf.length === 0 &&
        this.revendedora.rg.length === 0
      ) {
        return true;
      }

      if (this.revendedora.rg.length > 0 && this.revendedora.rg.length < 6) {
        this.$swal("RG inválido!", "", "error");
        return false;
      }

      if (!validateCPF(this.revendedora.cpf, this.classe_distribuidor)) {
        this.$swal("Um CPF Válido é Obrigatório!", "", "error");
        return false;
      }

      return true;
    },
    validateEndereco() {
      if (
        !this.classe_distribuidor === "G" &&
        this.revendedora.cep.length === 0 &&
        this.revendedora.logradouro.length === 0 &&
        this.revendedora.bairro.length == 0
      ) {
        /* console.log("CEP VAzio");*/
        return true;
      }

      if (
        this.classe_distribuidor === "G" &&
        (!this.revendedora.cep ||
          this.revendedora.cep == "" ||
          this.revendedora.cep.length < 10)
      ) {
        this.$swal("Informe um cep Válido!", "", "error");
        return false;
      }

      if (
        this.classe_distribuidor === "G" &&
        (this.revendedora.bairro.length < 3 ||
          this.revendedora.logradouro.length < 4)
      ) {
        this.$swal("Por favor, informe o Logradouro e Bairro", "", "error");
        return false;
      }

      return true;
    },
    validateContatos() {
      var retorno = true;
      this.revendedora.contatos.forEach(function (item, index) {
        if (item.numero.replace(/[^0-9]/g, "").length < 10) {
          alert("Contato " + index + " é inválido!");
          $(' a[href="#second-tab"]').tab("show");
          retorno = false;
        }
      }, retorno);

      return retorno;
    },
    formatRevendedora() {
      if (
        this.revendedora.app &&
        this.revendedora.app.user &&
        this.revendedora.app.user.app &&
        this.revendedora.app.user.status
      ) {
        this.revendedora.app.ativo = true;
      } else if (this.revendedora.app) {
        this.revendedora.app.ativo = false;
      }
    },
  },
  mounted() {
    this.getDistribuidor();
    this.getEstados();
    this.getPDV();
    this.formatRevendedora();
  },
  computed: {
    showContatos() {
      if (!this.revendedora.contatos) {
        return [];
      }
      return this.revendedora.contatos;
    },
    stateCPF() {
      var valido = false;
      if (this.revendedora.cpf) {
        var _cpf = this.revendedora.cpf.replace(/[^0-9]/g, "");
        if (_cpf.length === 11) {
          //console.log("statecpf ", _cpf);
          valido = validar(_cpf);
        }
      }
      return valido;
    },
    invalidCpf() {
      var valido = false;
      if (this.revendedora.cpf) {
        var _cpf = this.revendedora.cpf.replace(/[^0-9]/g, "");
        if (_cpf.length === 11) {
          //console.log("statecpf ", _cpf);
          valido = validar(_cpf);
          if (valido) {
            return "";
          } else {
            return "CPF Inválido.";
          }
        }
      }
      return "Informe um CPF Válido";
    },
    optionsRevend() {
      let data = [];
      this.lista_revendedoras.forEach((element) => {
        if (
          element.ativa !== false &&
          element.pessoa_fisica_id !== null &&
          element.pessoa_fisica &&
          element.pessoa_fisica.id
        ) {
          data.push({
            value: element.id,
            text: element.nome,
          });
        }
      });
      return data;
    },
    optionsPDV() {
      let data = [];
      this.pdvs.forEach((item) => {
        data.push({
          value: item.id,
          text: item.nome,
        });
      });
      return data;
    },
  },
};
</script>

<style>
  .pedido-pessoal {
    background-color: #f17a94;
    border-radius: 8px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/revendedora/form.vue